import * as Styles from './styles'

export const SkeletonValue = () => <Styles.SkeletonValue />
